import React, { createContext, useState, useContext, useEffect } from 'react';
import { authAPI } from '../services/api';

const AuthContext = createContext();

const fetchLcoFeatures = async (token) => {
  try {
    const r = await fetch((process.env.REACT_APP_API_URL||'')+'/api/lco/profile', 
      {headers:{'Authorization':'Bearer '+token}});
    const d = await r.json();
    return d.features || {};
  } catch(e) { return {}; }
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [tenant, setTenant] = useState(null);
  const [lcoFeatures, setLcoFeatures] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      authAPI.getMe()
        .then(async res => {
          setUser(res.data.user);
          setTenant(res.data.tenant);
          if(['lco','lco_tech','lco_accounts'].includes(res.data.user?.role)) {
            const features = await fetchLcoFeatures(token);
            setLcoFeatures(features);
          }
        })
        .catch(() => localStorage.clear())
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password, tenant_code) => {
    const res = await authAPI.login({ email, password, tenant_code });
    localStorage.setItem('token', res.data.token);
    localStorage.setItem('user', JSON.stringify(res.data.user));
    localStorage.setItem('tenant', JSON.stringify(res.data.tenant));
    setUser(res.data.user);
    setTenant(res.data.tenant);
    if(['lco','lco_tech','lco_accounts'].includes(res.data.user?.role)) {
      const features = await fetchLcoFeatures(res.data.token);
      setLcoFeatures(features);
    }
    return res.data;
  };

  const refreshLcoFeatures = async () => {
    const token = localStorage.getItem('token');
    if(token && ['lco','lco_tech','lco_accounts'].includes(user?.role)) {
      const features = await fetchLcoFeatures(token);
      setLcoFeatures(features);
    }
  };

  const logout = () => {
    localStorage.clear();
    setUser(null);
    setTenant(null);
    setLcoFeatures({});
    window.location.href = '/login';
  };

  return (
    <AuthContext.Provider value={{ user, tenant, lcoFeatures, loading, login, logout, refreshLcoFeatures }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
